import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { Container, Row, Col, Alert } from "react-bootstrap";
import ProductList from "../products/component/ProductList";
import Loading, { LoadingStates } from "../../components/Loading";

const Designs: React.FC = () => {
  const { user, isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return (
      <Loading state={LoadingStates.LOADING} message="Loading designs..." />
    );
  }

  if (!isAuthenticated) {
    return (
      <Container className="py-5">
        <Alert variant="warning">Please log in to view your designs.</Alert>
      </Container>
    );
  }

  return (
    <Container className="py-4">
      <Row className="mb-4">
        <Col>
          <h1 className="text-center display-4 mb-3">My Designs</h1>
          <p className="text-center text-muted">
            View and manage all your custom product designs
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <ProductList userId={user?.sub} showFilters={true} showActions={true} />
        </Col>
      </Row>
    </Container>
  );
};

export default Designs;
